/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import { PRIVATE_HOUSEBOAT_OWNER_TYPE } from '../../constants';
import SmartSelector from './SmartSelector';

export default class HouseboatDetail extends React.Component {
    static propTypes = {
        handleHouseboatChange: PropTypes.func,
        houseboat: PropTypes.shape({
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            registration_number: PropTypes.string,
        }),
        houseboatOptions: PropTypes.arrayOf(PropTypes.shape({})),
        isPrivateHouseboat: PropTypes.bool,
    };

    static defaultProps = {
        houseboat: {
            first_name: '',
            last_name: '',
            registration_number: '',
        },
        houseboatOptions: [],
        isPrivateHouseboat: false,
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.renderOwnerInformation = this.renderOwnerInformation.bind(this);
    }

    handleChange(event) {
        const houseboatObj = { ...this.props.houseboat };
        switch (event.target.id) {
            case 'houseboat-detail':
                const list = this.props.houseboatOptions.filter(
                    (h) => parseInt(h.type, 10) === parseInt(event.target.value, 10)
                );
                let houseboatName = '';
                if (list.length > 0) houseboatName = list[0].name;
                houseboatObj.type = parseInt(event.target.value, 10);
                houseboatObj.name = houseboatName;
                break;
            case 'houseboat-firstname':
                houseboatObj.first_name = event.target.value;
                break;
            case 'houseboat-lastname':
                houseboatObj.last_name = event.target.value;
                break;
            case 'houseboat-registration-num':
                houseboatObj.registration_number = event.target.value;
                break;
            default:
                return; // dont change anything
        }
        this.props.handleHouseboatChange(houseboatObj);
    }

    renderOwnerInformation() {
        const { isPrivateHouseboat, houseboat } = this.props;
        if (isPrivateHouseboat || houseboat.type === PRIVATE_HOUSEBOAT_OWNER_TYPE) {
            return (
                <FlexRow>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <label htmlFor="houseboat-firstname">First Name</label>
                            <input
                                type="text"
                                id="houseboat-firstname"
                                value={houseboat.first_name}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <label htmlFor="houseboat-lastname">Last Name</label>
                            <input
                                type="text"
                                id="houseboat-lastname"
                                value={houseboat.last_name}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={4}>
                        <div className="rec-form-item-wrap">
                            <label htmlFor="houseboat-registration-num">
                                Registration #
                            </label>
                            <input
                                type="text"
                                id="houseboat-registration-num"
                                value={houseboat.registration_number}
                                onChange={this.handleChange}
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            );
        }
        return null;
    }

    render() {
        const { houseboat } = this.props;
        const currentSelection = houseboat.type ? houseboat.type.toString() : '';
        const selectorProps = {
            name: 'houseboat-detail',
            id: 'houseboat-detail',
            value: currentSelection,
            handleChange: this.handleChange,
            options: this.props.houseboatOptions.map((a) => ({
                value: a.type.toString(),
                label: a.name,
            })),
            placeholderOption: { value: '', label: 'Select from list' },
            includePlaceholderOption: true,
            disabled: false,
            label: 'Ownership Type',
            isLabelVisible: true,
        };

        return (
            <div className="per-houseboat-form per-section-group">
                <div className="rec-order-detail-subsection-title">
                    Houseboat Ownership
                </div>
                <p>
                    If privately owned, please enter the first name, last name, and boat
                    registration number of the houseboat owner.
                </p>
                <FlexRow>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <SmartSelector {...selectorProps} />
                        </div>
                    </FlexCol>
                </FlexRow>
                {this.renderOwnerInformation()}
            </div>
        );
    }
}
